import { render, staticRenderFns } from "./TextMaterialsSlider.vue?vue&type=template&id=71ba9816&scoped=true"
import script from "./TextMaterialsSlider.vue?vue&type=script&lang=js"
export * from "./TextMaterialsSlider.vue?vue&type=script&lang=js"
import style0 from "./TextMaterialsSlider.vue?vue&type=style&index=0&id=71ba9816&prod&lang=scss&scoped=true"
import style1 from "./TextMaterialsSlider.vue?vue&type=style&index=1&id=71ba9816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ba9816",
  null
  
)

export default component.exports